import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AlertsApi } from "src/services/Api/Organization/types";
import { Loading } from "go-core/components/Loading";
import { useWindowSize } from "go-core/components/useWindowSize";
import { DashboardProductsList } from "./DashboardProductsList";

interface DashboardProductsSectionProps {
	isLoading: boolean;
	alertsData?: AlertsApi;
}

export const DashboardProductsSection = ({ isLoading, alertsData }: DashboardProductsSectionProps) => {
	const { t } = useTranslation();
	const [stocksList, setStocksList] = useState(alertsData?.below_zero_stocks);
	const { isMobile } = useWindowSize();

	useEffect(() => {
		setStocksList(alertsData?.below_zero_stocks);
	}, [alertsData?.below_zero_stocks]);

	if (!isLoading && !stocksList?.length) {
		return null;
	}

	return (
		<Card className={`w-100 p-4 ${isMobile ? "px-2" : ""}`}>
			<Card.Title>{t("modules.dashboard.stocks_list.header.title")}</Card.Title>
			{isLoading ? (
				<Loading />
			) : (
				<div>
					{stocksList?.map((stock) => (
						<React.Fragment key={stock.stock_id}>
							<hr />
							<DashboardProductsList stock={stock} />
						</React.Fragment>
					))}
				</div>
			)}
		</Card>
	);
};
